export const getTellMoneyUserConsentKey = (stateKey: string) => [
    'tell-money-user-consent',
    stateKey
];

export const getTellMoneyUserConsentByConsentIdKey = (
    stateKey: string,
    consentId: string
) => ['tell-money-user-consent-id', stateKey, consentId];
